// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2i-dt"};